/* Zombie Snacks — cart drawer title count ("YOUR BUNKER (2)")
 *
 * Taiga re-renders #cart-items after every add / quantity change / removal
 * but not the drawer header. cart-items.liquid carries the live
 * cart.item_count in a hidden [data-zombie-cart-count]; this copies it into
 * the title whenever #cart-items changes. Display only — no cart logic.
 */
(function () {
  'use strict';

  function sync() {
    var source = document.querySelector('#cart-items [data-zombie-cart-count]');
    var label = document.querySelector('#drawer-cart [data-zombie-cart-count-label]');
    if (!source || !label) return;
    var count = parseInt(source.getAttribute('data-zombie-cart-count'), 10) || 0;
    label.textContent = count > 0 ? '(' + count + ')' : '';
  }

  function init() {
    var items = document.getElementById('cart-items');
    if (!items) return;
    sync();
    new MutationObserver(sync).observe(items, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
